<template>
	<section class="section login">
		<div class="columns is-centered">
			<div class="column is-6 is-4-fullhd">
				<h4 class="title is-left">{{ $t('Register') }}</h4>
				<b-field
					:type="{ 'is-danger': validation['firstName']}"
					:message="validation['firstName'] && $t('First name is required')"
            		:label="$t('First Name')" label-for="firstName">
					<b-input
						required
						:placeholder="$t('First Name')"
						type="text"
						v-model="user.firstName"
						:counter="10"
						id="firstName"
					></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['lastName']}"
            		:message="validation['lastName'] && $t('Last name is required')"
					:label="$t('Last Name')"
					label-for="lastName">
					<b-input
						required
						:placeholder="$t('Last Name')"
						type="text"
						v-model="user.lastName"
						:counter="10"
						id="lastName"
					></b-input>
				</b-field>

				<b-field
					:type="{ 'is-danger': validation['country_code']}"
					:message="validation['country_code'] && $t('Country name is required')"
					:label="$t('Country')" label-for="country_code">
					<b-input
						required
						:placeholder="$t('Country')"
						type="text"
						v-model="user.country_code"
						:counter="10"
						id="country_code"
					></b-input>
				</b-field>
				<b-field
					:type="{ 'is-danger': validation['region']}"
					:message="validation['region'] && $t('Valid region is required')"
					:label="$t('State/Province')" label-for="region">
					<b-input
						required
						:placeholder="$t('Region')"
						type="text"
						v-model="user.region"
						:counter="10"
						id="region"
					></b-input>
				</b-field>

				<b-field :type="{ 'is-danger': validation['postcode']}"
            		:message="validation['postcode'] && $t('Valid Zip/Postal Code is required')"
					:label="$t('Zip/Postal Code')" label-for="postcode">
					<b-input
						required
						:placeholder="$t('Zip/Postal Code')"
						type="text"
						v-model="user.postcode"
						:counter="10"
						id="postcode"
					></b-input>
				</b-field>
				<b-field
					:type="{ 'is-danger': validation['city']}"
					:message="validation['city'] && $t('Valid city is required')"
					:label="$t('City')" label-for="city">
					<b-input
						:placeholder="$t('City')"
						type="text"
						v-model="user.city"
						:counter="10"
						id="city"
					></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['address']}"
            		:message="validation['address'] && $t('Valid street address is required')"
					:label="$t('Street Address')" label-for="address">
					<b-input
						required
						:placeholder="$t('Street Address')"
						type="text"
						v-model="user.address"
						:counter="10"
						id="address"
					></b-input>
				</b-field>

				<b-field :type="{ 'is-danger': validation['phone']}"
            		:message="validation['phone'] && $t('Valid phone number is required')"
					:label="$t('Phone Number')" label-for="phone">
					<b-input
						required
						:placeholder="$t('Phone Number')"
						type="text"
						v-model="user.phone"
						:counter="10"
						id="phone"
					></b-input>
				</b-field>

				<b-field :type="{ 'is-danger': validation['email']}"
            		:message="validation['email'] && $t('Email is not valid')"
					:label="$t('E-mail')" label-for="email">
					<b-input
						required
						:placeholder="$t('E-mail')"
						type="email"
						v-model="user.email"
						:counter="10"
						icon="envelope"
						id="email"
					></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['password']}"
					:message="validation['password'] && $t('Password should be atleast 8 characters')"
            		:label="$t('Password')"
					label-for="password">
					<b-input
						required
						type="password"
						v-model="user.password"
						password-reveal
						id="password"
					></b-input>
				</b-field>
				<b-field :type="{ 'is-danger': validation['confirmPassword']}"
            		:message="validation['confirmPassword'] && $t('Passwords should match')"
					:label="$t('Confirm Password')" label-for="confirmPassword">
					<b-input
						required
						type="password"
						v-model="user.confirmPassword"
						password-reveal
						id="confirmPassword"
					></b-input>
				</b-field>

				<b-button type="is-primary" @click="register">{{ $t('Register') }}</b-button>
				<hr>
				<div class="box has-text-centered">
					<p>
						{{ $t('Already have an account?') }}
					</p>
					<b-button
						v-if="this.$i18n.locale == 'hu'"
						type="is-primary"
						outlined
						@click="login"
						>{{ $t('Login') }}</b-button
					>
					<b-button
						v-else
						type="is-primary"
						outlined
						@click="login"
						>{{ $t('Login') }}</b-button
					>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: 'Register',
	components: {},
	metaInfo () {
		return {
			title: this.$t("Register"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			user: {
				firstName:'',
				lastName:'',
				taxVatNumber:'',
				email: '',
				password: '',
				confirmPassword:''
			},
			validation: {},
		}
	},
	methods: {
		login: function () {
			var _this = this
			_this.$router.push({name:'Login'})
		},
		register: function() {
			this.validation= {};
			//register form validation

			if(!this.user.firstName || this.user.firstName === ''){
				this.validation["firstName"] = "Error";
			}

			if(!this.user.lastName || this.user.lastName === ''){
				this.validation["lastName"] = "Error";
			}

			if(!this.user.region || this.user.region === ''){
				this.validation["region"] = "Error";
			}

			if (!this.user.postcode || this.user.postcode === '') {
				this.validation["postcode"] = "Error";
			}

			if (!this.user.city || this.user.city === '') {
				this.validation["city"] = "Error";
			}

			if(!this.user.country_code || this.user.country_code === ''){
				this.validation["country_code"] = "Error";
			}

			if (!this.user.address || this.user.address === '') {
				this.validation["address"] = "Error";
			}

			if (!this.user.phone || this.user.phone === '') {
				this.validation["phone"] = "Error";
			}

			if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)) {
				this.validation["email"] = "Error";
			}

			if (!this.user.password || this.user.password.length < 8) {
				this.validation["password"] = "Error";
			}

			if (!this.user.confirmPassword || this.user.confirmPassword !== this.user.password) {
				this.validation["confirmPassword"] = "Error";

			}
			if(Object.keys(this.validation).length !== 0){
				return;
			}

			//register api call

			var _this = this
			this.$http
				.post('/users/register', this.user)
				.then((response) => {
					console.log("user/register:", response, _this.$socket.id);
					_this.$http.defaults.headers.Authorization = response.data.token
					localStorage.setItem('token', response.data.token)
					console.log('____login data:', response.data)
					if (response.data.user.UserPreference) {
						localStorage.setItem('lang', response.data.user.UserPreference.language)
						localStorage.setItem('currency', response.data.user.UserPreference.currency)
					}
					localStorage.setItem('loggedIn', true)
					_this.$store.commit('setToken', response.data.token)
					_this.$store.commit('setUser', response.data.user)
					_this.$store.commit('setLoggedIn', true)
					_this.$store.commit('setRole', response.data.user.role)
					_this.$buefy.snackbar.open({
						message: _this.$t('Successful registration'),
						position: 'is-top',
						queue: false,
					})
					console.log('ROUTE', _this.$route)
					_this.$router.replace({ path: '/' })
				})
				.catch((error) => {
					console.log(JSON.stringify(error));
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed registration'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
						queue: false,
					})
				})
		}
	},
}
</script>
